export default __webpack_public_path__ + "static/port-terminal-c2edd623eda33e73ef7efcb591210fbc.png";